import { useEffect, useState } from 'react';

// Include touch devices even when landscape or desktop mode widens the viewport.
const MOBILE_VIEW = '(max-width: 820px), (hover: none) and (pointer: coarse)';

export default function useMobileView() {
  const [mobile, setMobile] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(MOBILE_VIEW).matches);
  useEffect(() => {
    const media = window.matchMedia?.(MOBILE_VIEW);
    if (!media) return;
    const update = () => setMobile(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return mobile;
}
